import SiteNav from '../components/SiteNav';
import SiteFooter from '../components/SiteFooter';
import Seo from '../components/Seo';
import Hero from '../components/landing/Hero';
import LawStrip from '../components/landing/LawStrip';
import Contrast from '../components/landing/Contrast';
import Pillars from '../components/landing/Pillars';
import SafePlace from '../components/landing/SafePlace';
import Pricing from '../components/landing/Pricing';
import Comparison from '../components/landing/Comparison';
import Faq from '../components/landing/Faq';
import FinalCta from '../components/landing/FinalCta';
import {
  jsonLdGraph,
  organizationSchema,
  websiteSchema,
  softwareApplicationSchema,
} from '../lib/seo';
import '../styles/landing.css';

export default function LandingPage() {
  return (
    <>
      <Seo
        title="reeve: Stop losing hours getting HR right"
        description="reeve is an AI advisor that gets your HR right, from the right contracts to what to do when things go wrong, answered in seconds. UK small businesses stop losing hours, and money, to HR."
        path="/"
        jsonLd={[jsonLdGraph([organizationSchema, websiteSchema, softwareApplicationSchema])]}
      />
      <SiteNav />
      <main className="landing-main">
        <Hero />
        <LawStrip />
        <Contrast />
        <Pillars />
        <SafePlace />
        <Pricing />
        <Comparison />
        <Faq />
        <FinalCta />
      </main>
      <SiteFooter />
    </>
  );
}
